var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCmLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.15 1.79 6.21 3.85 8 8 C8.53 12.98 8.17 16.07 5 20 C1.07 23.17 -2.02 23.53 -7 23 C-11.15 21.21 -13.21 19.15 -15 15 C-15.53 10.02 -15.17 6.93 -12 3 C-8.07 -0.17 -4.98 -0.53 0 0 Z ",
    fill: "#009696",
    transform: "translate(16,1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 1.69 2.31 1.69 4 4 C4.25 6.75 4.25 6.75 4 9 C2.68 9 1.36 9 0 9 C0 10.32 0 11.64 0 13 C-3.21 13.36 -4.64 13.24 -7.38 11.44 C-9 9 -9 9 -8.94 5.38 C-7.54 0.36 -4.94 -0.72 0 0 Z ",
    fill: "#091616",
    transform: "translate(15,6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmLogo);
export default __webpack_public_path__ + "static/media/cm_logo.c089bbde554b17a180ed6e6b79693706.svg";
export { ForwardRef as ReactComponent };